/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef} from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSSelect from "components/Forms/TSSelect";
import TSSelect2 from "components/Forms/TSSelect2";
import TSText from "components/Forms/TSText";
import TSRadio from "components/Forms/TSRadio";
import { Collapse, Modal, ModalBody } from "reactstrap";
// import avatar from "assets/img/faces/marc.jpg";
import {
  Input,
  Label,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import "./custom-style.css";


const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  },
};

const primaryColor = "#af2cc5";

const useStyles = makeStyles(styles);

const Request = (props) => {

  const [RepairTypeKey, setRepairTypeKey] = useState(null);
  const [RepairSubTypeKey, setRepairSubTypeKey] = useState(null);

  const [AssetKey, setAssetKey] = useState(null);
  const [AssetCode, setAssetCode] = useState('');
  const [AssetName, setAssetName] = useState('');
  const [RepairNote, setRepairNote] = useState('');

  const [isCheckAsset, setIsCheckAsset] = useState(false);


  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [modal4, setModal4] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [icon2, setIcon2] = useState("far fa-question-circle");

  const [isOpen, setIsOpen] = useState(false);

  const urgentList = [{ label:"ปกติ", value:0}, { label:"ด่วน", value:1} , { label:"ฉุกเฉิน", value:2}];

  const myRef = useRef(null);

  const handleSubmit = evt => {
    evt.preventDefault();
    console.log(RepairTypeKey)
    var cntErr = 0;

    var errMsg = [];
  /*
    if (name === null || name === "") {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อตัวชี้วัด"}</li>);
    }

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal(true);
    }
  */
  };

  const handleConfirm = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

  };

  

  useEffect(() => {


  }, []);



    const test = e => {
        myRef.current.scrollIntoView()
    };

    const classes = useStyles();

    return (

        <div>

            <Grid>

                <Col xs={12} sm={12} md={12}>

                    <Card>
                        <CardHeader color="primary">

                            <h4 className={classes.cardTitleWhite}>แบบฟอร์มขอแจ้งซ่อม</h4>
                            <p className={classes.cardCategoryWhite}> กรุณาระบุรายละเอียด </p>

                        </CardHeader>

                        <CardBody>
                            <Grid>
                                <Col xs={12} sm={6} md={6}>
                                    <TSSelect2 label="หน่วยงานซ่อม" options={urgentList} value={RepairTypeKey} placeholder="ค้นหาหน่วยงานซ่อม" onChange={e => setRepairTypeKey(e.value) } />
                                </Col>
                                <Col xs={12} sm={6} md={6}>
                                    <TSSelect2 label="ประเภทการซ่อม" options={urgentList} value={RepairSubTypeKey} placeholder="ค้นหาประเภทการซ่อม" onChange={e => setRepairSubTypeKey(e.value)} />
                                </Col>
                            </Grid>
                            
                            <Grid>
                              <Col xs={12} sm={12} md={12}>
                                <Label style={{ marginLeft: '20px' }} ><Input style={{ marginTop: 0, width: '20px', height: '20px', border:'1px solid black' }} type="checkbox" onChange={() => setIsCheckAsset(!isCheckAsset)} />&nbsp;&nbsp;ไม่มีรายการครุภัณฑ์</Label> 
                              </Col>
                            </Grid>
                            <Grid>
                                {
                                (!isCheckAsset) ? 
                                <>
                                  <Col xs={12} sm={6} md={6}>
                                      <TSSelect2 label="ข้อมูลครุภัณฑ์" options={urgentList} value={AssetKey} placeholder="ค้นหาครุภัณฑ์" onChange={e => setAssetKey(e.value)} />
                                  </Col>
                                  <Col xs={12} sm={6} md={6}>
                                      <TSText label="หมายเลขครุภัณฑ์" value={AssetCode} onChange={e => setAssetCode(e.target.value)} />
                                  </Col>
                                </>
                                :
                                <Col xs={12} sm={12} md={12}>
                                    <TSText label="รายการที่ขอ" value={AssetName} placeholder="ระบุรายการที่ขอแจ้งซ่อม" onChange={e => setAssetName(e.target.value)} />
                                </Col>
                                }
    
                            </Grid>

                            <Grid>
                              <Col xs={12} sm={12} md={12}>
                                <div className="textarea-container" style={{ padding: 0 }}>
                                      <Label for="Address">รายละเอียดที่ชำรุด </Label>  
                                          {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                      <Input
                                          id="Address"
                                          cols="80"
                                          name="ShippingAddress"
                                          placeholder="รายละเอียดที่ชำรุด"
                                          rows="4"
                                          type="textarea"
                                          className="custom"
                                          style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                          value={RepairNote}
                                          onChange={e => setRepairNote(e.target.value) }
                                          ></Input>
                                  </div>
                              </Col>
                            </Grid>


                            <Grid>
                                <Col xs={12} sm={6} md={6}>
                                    <TSRadio options={urgentList} />
                                </Col>
                            </Grid>

                            <Grid>
                                <Col xs={12} sm={6} md={3} style={{ height: "48px" }}>
                                    <div style={{ textAlign: "center", overflow: "overlay" }}>
                                        <Button color="info" onClick={handleSubmit}>
                                            <h4>บันทึก</h4>
                                        </Button>
                                    </div>
                                </Col>
                            </Grid>


                      </CardBody>
                      <CardFooter>
                          <Collapse isOpen={isOpen}>

                          </Collapse>
                          {/* Confirm */}
                          <Modal toggle={() => setModal(false)} isOpen={modal}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className={icon}
                                  style={{ color: "blue", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p
                                style={{
                                  textAlign: "center"
                                }}
                              >
                                {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                  ? "ยืนยันการบันทึกข้อมูล"
                                  : "กำลังตรวจสอบข้อมูล"}
                              </p>
                              <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
                              <Button
                                color="primary"
                                type="button"
                                onClick={() => setModal(false)}
                              >
                                <h4>ยกเลิก</h4>
                              </Button>

                              <Button
                                color="primary"
                                type="button"
                                onClick={handleConfirm}
                                disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                              >
                                <h4>ยืนยัน</h4>
                              </Button>
                            </div>
                          </Modal>

                          {/* Error */}
                          <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className="fa fa-times"
                                  style={{ color: "red", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p>ไม่สามารถบันทึกข้อมูลได้</p>
                              <div>{errMsg}</div>
                            </ModalBody>
                            <div className="modal-footer justify-content-center">
                              <Button
                                color="primary"
                                type="button"
                                onClick={() => setModalError(false)}
                              >
                                <h4>ตกลง</h4>
                              </Button>
                            </div>
                                      </Modal>
                      </CardFooter>
                  </Card>
              </Col>
            </Grid>
        </div>
    );
}
export default Request;